import React from "react"

import {AggregateFunctionName, AggregateFunctionType} from "../../../../data-structures/aggregators/types"

type Props = {
    menuParams: {
        options             : string[]
        onClickOption       : {(value:string|null):void}
        aggregateFunction   : string
    }
    hidePopover: callback
}

export default function AggregateMoreMenu(props:Props) {

    const onClickOption = (value:string|null) => {
        props.hidePopover();
        props.menuParams.onClickOption(value);
    };

    const maxOptionWidth = _.chain(props.menuParams.options)
        .map(option=> gd.utils.getTextWidth(gd.const.aggregate.name[option]) + 50)
        .max()
        .value();

    const styles = {width: maxOptionWidth > 160 ? '200px' : '160px'};

    return (
        <div className="ui5-popover-menu" style={styles}>
            <div className="h-36 flex-row-left-center p-l-15 p-r-15 border-box">
                <div className="ui5-title-smaller-dark txt-semibold">Function</div>
            </div>

            {_.map(props.menuParams.options, (option, key) => {
                const classes = Classes('option', /*'with-icon',*/ {
                    selected: props.menuParams.aggregateFunction === option
                });

                return (
                    <div key={key} className={classes} onClick={()=>{onClickOption(option)}}>
                        {/*<div className={Classes("ico", gd.const.aggregate.icon[option])}/>*/}
                        <div className="label">{AggregateFunctionName[option as AggregateFunctionType]}</div>
                    </div>
                );
            })}

            {!!props.menuParams.aggregateFunction &&
            <div className="option" onClick={()=>{onClickOption(null)}}>
                <div className="label">None</div>
            </div>}
        </div>
    );
}